import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ErrorBanner } from 'rhombus-react';

import { getPlacementErrorByAdType } from 'selectors/Social2';
import { prettifyMessages } from 'social/utils';
import { SOCIAL_AD_TYPES } from 'utils/constants';

export default function PlacementErrorBanner(props) {
	const { adType, placementType, showPristineErrors } = props;
	const { errorMessages } = useSelector(getPlacementErrorByAdType(adType, placementType, showPristineErrors));

	const prettyErrorMessages = useMemo(() => (
		prettifyMessages(errorMessages)
	), [errorMessages]);

	return (
		<ErrorBanner
			title="Sorry, please fix the errors below"
			messages={prettyErrorMessages}
			shouldDisplay={Boolean(prettyErrorMessages.length)}
		/>
	);
}

PlacementErrorBanner.propTypes = {
	adType: PropTypes.oneOf([
		SOCIAL_AD_TYPES.FACEBOOK_IMAGE,
		SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO,
		SOCIAL_AD_TYPES.FACEBOOK_VIDEO,
		SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO,
	]).isRequired,
	placementType: PropTypes.string.isRequired,
	showPristineErrors: PropTypes.bool,
};
